import type { Group, Pouch, Sheet, SheetHistoryEntry, SheetSnapshot } from '../../types';

/** IDB / API 入出力: パウチの一時 UI フラグを除去（StorageUtils.stripPouchUiFlagsForLoad と同等） */
export function stripPouchUiFlagsForApi(pouch: Pouch): Pouch {
  const p = pouch as Pouch & Record<string, unknown>;
  const {
    _isDragging,
    _isCloneSource,
    _isCloning,
    _isFromOtherSheet,
    _isMoving,
    _isDeleting,
    _bounceBack,
    _isCrossSheetDrag,
    _animateSubtotal,
    _isInMuteGroup,
    _isAdding,
    _previousSubtotal,
    _animateFromZero,
    _animateSignChange,
    _animateMultiplier,
    _noTransition,
    _isGtpRenderPreview,
    ...clean
  } = p;
  return clean as Pouch;
}

/** グループの一時 UI フラグを除去 */
export function stripGroupUiFlagsForApi(group: Group): Group {
  const g = group as Group & Record<string, unknown>;
  const {
    _isCloning,
    _isDragging,
    _isFromOtherSheet,
    _animateSubtotal,
    _previousSubtotal,
    _isInMuteGroup,
    _animateFromZero,
    _isAdding,
    _isDeleting,
    ...clean
  } = g;
  return clean as Group;
}

export function stripHistoryEntryUiFlags(entry: SheetHistoryEntry): SheetHistoryEntry {
  return {
    ...entry,
    pouches: entry.pouches.map(stripPouchUiFlagsForApi),
    groups: entry.groups.map(stripGroupUiFlagsForApi),
  };
}

export function stripSnapshotUiFlags(snapshot: SheetSnapshot): SheetSnapshot {
  return {
    ...snapshot,
    pouches: snapshot.pouches.map(stripPouchUiFlagsForApi),
    groups: snapshot.groups.map(stripGroupUiFlagsForApi),
  };
}

/** シート全体から UI 一時フラグを除去 */
export function stripSheetUiFlags(sheet: Sheet): Sheet {
  return {
    ...sheet,
    pouches: sheet.pouches.map(stripPouchUiFlagsForApi),
    groups: sheet.groups.map(stripGroupUiFlagsForApi),
    history: (sheet.history ?? []).map(stripHistoryEntryUiFlags),
    snapshots: (sheet.snapshots ?? []).map(stripSnapshotUiFlags),
  };
}
